import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";

const RecentArticleCommentReply = ({
  reply: { avatar, channelid, text, firstname, lastname, jobtitle, date },
}) => {
  return (
    <Fragment>
      <div className="reply">
        <div className="reply-connect">
          <div className="connect background-green"></div>
        </div>
        <div className="comment-user">
          <div className="comment-avi-container">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
              alt="avatar"
              className="comment-avi"
            />
          </div>
          <div className="comment-user-info">
            <div className="comment-user-name green">{channelid}</div>
            <div className="comment-user-job-title white">
              {firstname} {lastname}
            </div>
            <div className="comment-user-job-title">
              <i className="far fa-address-card green"></i>
              <span className="job-title">{jobtitle}</span>
            </div>
          </div>
          <div className="comment-header-container">
            <div className="comment-date">
              <Moment format="MM/DD/YYYY">{date}</Moment>
            </div>
            <i className="fas fa-ellipsis-v fa-lg pt green"></i>
            <div className="modal">
              <ul className="modal-items">
                <li className="modal-item">
                  <i className="fas fa-flag mx-5 white"></i>
                  Report
                </li>
                <li className="modal-item">
                  <i className="fas fa-ban mx-5 white"></i>
                  Block
                </li>
                <li className="modal-item">
                  <i className="fas fa-times mx-5 white"></i>
                  Delete
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="comment-text-container">
          <p className="post-text-comment">{text}</p>
        </div>
        <div className="comment-action-buttons">
          <div className="comment-left-buttons">
            <i className="far fa-thumbs-up mx-5 green"></i>
            <span className="white">28</span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

RecentArticleCommentReply.propTypes = {
  reply: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(RecentArticleCommentReply);
